import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import ImageContentful from "./ImageContentful"
import { media, mixins } from "../styles"

export const Author = styled.div`
  align-items: center;
  display: flex;
`

export const AuthorAvatar = styled.div`
  border-radius: 50%;
  flex: none;
  height: 60px;
  margin: 0 15px 0 0;
  overflow: hidden;
  transform: translate3d(0, 0, 0); /* Safari overflow fix */
  width: 60px;

  @media ${media.md} {
    margin: 0 30px 0 0;
    height: 90px;
    width: 90px;
  }

  @media ${media.lg} {
    margin: 0 45px 0 0;
    height: 120px;
    width: 120px;
  }
`

export const AuthorMeta = styled.div`
  ${mixins.copy1}
  display: flex;
`

export const AuthorDash = styled.span`
  display: none;
  margin-right: 20px;

  @media ${media.md} {
    display: block;
  }
`

export const AuthorName = styled.div``

export const AuthorTitle = styled.p`
  ${mixins.copy5}
  opacity: 0.5;
  margin: 0;
`

const TestimonialAuthor = ({ className, name, photo, title, ...props }) => {
  return (
    <Author className={className} {...props}>
      {photo && (
        <AuthorAvatar>
          <ImageContentful alt={name} image={photo} loading="eager" />
        </AuthorAvatar>
      )}
      <AuthorMeta>
        <AuthorDash aria-hidden="true">—</AuthorDash>
        <span>
          <AuthorName>{name}</AuthorName>
          <AuthorTitle>{title}</AuthorTitle>
        </span>
      </AuthorMeta>
    </Author>
  )
}

TestimonialAuthor.propTypes = {
  name: PropTypes.string.isRequired,
  photo: PropTypes.object,
  title: PropTypes.string,
  className: PropTypes.string,
}

export default TestimonialAuthor
